import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgPreviousPage = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="12"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 12 12"
    >
        <g clipPath="url(#clip0)">
            <path
                d="M8.26121 0.0956182L2.77308 5.76937C2.71372 5.83147 2.68058 5.91408 2.68058 5.99999C2.68058 6.08591 2.71372 6.16851 2.77308 6.23062L8.26121 11.9044C8.28994 11.9347 8.32454 11.9588 8.3629 11.9753C8.40126 11.9918 8.44258 12.0003 8.48434 12.0003C8.52609 12.0003 8.56741 11.9918 8.60577 11.9753C8.64413 11.9588 8.67873 11.9347 8.70746 11.9044L9.22684 11.3681C9.2862 11.306 9.31934 11.2234 9.31934 11.1375C9.31934 11.0516 9.2862 10.969 9.22684 10.9069L4.49058 5.99999L9.22684 1.09312C9.2862 1.03102 9.31934 0.948409 9.31934 0.862494C9.31934 0.776578 9.2862 0.693973 9.22684 0.631868L8.70746 0.0956182C8.67873 0.065321 8.64413 0.041193 8.60577 0.024704C8.56741 0.00821495 8.52609 -0.000287056 8.48434 -0.000287056C8.44258 -0.000287056 8.40126 0.00821495 8.3629 0.024704C8.32454 0.041193 8.28994 0.065321 8.26121 0.0956182Z"
                fill="#373739"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect
                    fill="white"
                    height="12"
                    transform="matrix(0 -1 -1 0 12 12)"
                    width="12"
                />
            </clipPath>
        </defs>
    </svg>
);

export const PreviousPageIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgPreviousPage}
        fontSize={fontSize}
    />
);
